export default {
  picks: {
    imageImport: {
      dropzoneBody: "Importa una foto y tomaremos los picks por ti.",
      dropzoneCta: "Haz clic aquí o arrastra y suelta para subirla",
      preparingResults: "Preparando resultados",
      adding: "Agregando...",
      importedPicks: "Picks importados",
    },
    actions: {
      findTrends: "Encontrar tendencias",
    },
    labels: {
      sgpPricingUnavailable: "Precio SGP no disponible",
    },
    plusPromo: {
      description: "Obtén acceso a jugadas avanzadas y análisis más profundos",
    },
  },
};